import React from 'react';
import Lottie from 'react-lottie';
import loadingIcon from '@graphic/loadingIcon.json';

interface LoadingIconProps {
  size?: number;
}

const LoadingIcon = ({ size = 64 }: LoadingIconProps) => {
  const loadingOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingIcon,
  };

  return <Lottie width={size} height={size} options={loadingOptions} isClickToPauseDisabled={true} />;
};

export default LoadingIcon;
